// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles__alternatives___Qrxyl {
  margin-top: 16px;
  margin-bottom: 20px;
}
.styles__alternativesContainer___pmThJ {
  margin-top: 0.5em;
}
.styles__best___fP3OG {
  color: #1ec188 !important;
}
.styles__svg-best___JsP03 {
  fill: #1ec188 !important;
}
.styles__ideal___Dv1_W {
  color: #5bc0de !important;
}
.styles__svg-ideal___t0YhN {
  fill: #5bc0de !important;
}
.styles__warning___F7rgX {
  color: #f0ad4e !important;
}
.styles__svg-warning___S3GOy {
  fill: #f0ad4e !important;
}
.styles__legal___VJzAo {
  color: #b98234 !important;
}
.styles__svg-legal___qhFlf {
  fill: #b98234 !important;
}
.styles__illegal___CS8OL {
  color: #d9534f !important;
}
.styles__svg-illegal___hCGIt {
  fill: #d9534f !important;
}
.styles__label___cu6Iv {
  text-transform: uppercase;
  font-size: 12px;
}
.styles__diametersWrapper___E5BPV {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.styles__diametersWrapper___E5BPV .styles__diameter___NRoSQ {
  display: flex;
  position: relative;
  align-items: center;
  min-width: 28px;
  width: 28px;
  height: 28px;
  margin-right: 3px;
  padding: 4px 2px 2px 2px;
  font-size: 14px;
  cursor: pointer;
}
.styles__diametersWrapper___E5BPV .styles__diameter___NRoSQ .styles__label___cu6Iv {
  text-align: center;
  font-weight: bold;
  width: 100%;
}
.styles__diametersWrapper___E5BPV .styles__diameter___NRoSQ .styles__checkedIcon___kiF1l {
  position: absolute;
  top: 1px;
  left: 1px;
  font-size: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/components/components/Search/TyreSearch/TyreAlternatives/styles.less"],"names":[],"mappings":"AAEA;EACE,gBAAA;EACA,mBAAA;AADF;AAIA;EACE,iBAAA;AAFF;AAKA;EACE,yBAAA;AAHF;AAMA;EACE,wBAAA;AAJF;AAOA;EACE,yBAAA;AALF;AAQA;EACE,wBAAA;AANF;AASA;EACE,yBAAA;AAPF;AAUA;EACE,wBAAA;AARF;AAWA;EACE,yBAAA;AATF;AAYA;EACE,wBAAA;AAVF;AAaA;EACE,yBAAA;AAXF;AAcA;EACE,wBAAA;AAZF;AAeA;EACE,yBAAA;EACA,eAAA;AAbF;AAgBA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AAdF;AAWA;EAMI,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,wBAAA;EACA,eAAA;EACA,eAAA;AAdJ;AADA;EAkBM,kBAAA;EACA,iBAAA;EACA,WAAA;AAdN;AANA;EAwBM,kBAAA;EACA,QAAA;EACA,SAAA;EACA,cAAA;AAfN","sourcesContent":["@import '../../../../../shared/variables.less';\n\n.alternatives {\n  margin-top: 16px;\n  margin-bottom: 20px;\n}\n\n.alternativesContainer {\n  margin-top: 0.5em;\n}\n\n.best {\n  color: @tyre-alt-best !important;\n}\n\n.svg-best {\n  fill: @tyre-alt-best !important;\n}\n\n.ideal {\n  color: @tyre-alt-ideal !important;\n}\n\n.svg-ideal {\n  fill: @tyre-alt-ideal !important;\n}\n\n.warning {\n  color: @tyre-alt-warning !important;\n}\n\n.svg-warning {\n  fill: @tyre-alt-warning !important;\n}\n\n.legal {\n  color: @tyre-alt-legal !important;\n}\n\n.svg-legal {\n  fill: @tyre-alt-legal !important;\n}\n\n.illegal {\n  color: @tyre-alt-illegal !important;\n}\n\n.svg-illegal {\n  fill: @tyre-alt-illegal !important;\n}\n\n.label {\n  text-transform: uppercase;\n  font-size: 12px;\n}\n\n.diametersWrapper {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n\n  .diameter {\n    display: flex;\n    position: relative;\n    align-items: center;\n    min-width: 28px;\n    width: 28px;\n    height: 28px;\n    margin-right: 3px;\n    padding: 4px 2px 2px 2px;\n    font-size: 14px;\n    cursor: pointer;\n\n    .label {\n      text-align: center;\n      font-weight: bold;\n      width: 100%;\n    }\n\n    .checkedIcon {\n      position: absolute;\n      top: 1px;\n      left: 1px;\n      font-size: 8px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"alternatives": `styles__alternatives___Qrxyl`,
	"alternativesContainer": `styles__alternativesContainer___pmThJ`,
	"best": `styles__best___fP3OG`,
	"svg-best": `styles__svg-best___JsP03`,
	"ideal": `styles__ideal___Dv1_W`,
	"svg-ideal": `styles__svg-ideal___t0YhN`,
	"warning": `styles__warning___F7rgX`,
	"svg-warning": `styles__svg-warning___S3GOy`,
	"legal": `styles__legal___VJzAo`,
	"svg-legal": `styles__svg-legal___qhFlf`,
	"illegal": `styles__illegal___CS8OL`,
	"svg-illegal": `styles__svg-illegal___hCGIt`,
	"label": `styles__label___cu6Iv`,
	"diametersWrapper": `styles__diametersWrapper___E5BPV`,
	"diameter": `styles__diameter___NRoSQ`,
	"checkedIcon": `styles__checkedIcon___kiF1l`
};
export default ___CSS_LOADER_EXPORT___;
